import { createFileRoute } from "@tanstack/react-router";
import { requirePermission } from "@/lib/casl/route-guards.ts";
import { TrainingSession } from "@/components/training-simulator/session/training-session.tsx";

export const Route = createFileRoute(
  "/_authenticated/training/session/$attemptId",
)({
  component: TrainingSessionRoute,
  beforeLoad: ({ context }) => {
    requirePermission(context.user, "read", "training-simulator");
  },
});

function TrainingSessionRoute() {
  const { attemptId } = Route.useParams();

  return <TrainingSession key={attemptId} attemptId={attemptId} />;
}
